import { initializeApp } from "firebase/app";
import { getAuth, signOut, signInWithEmailAndPassword } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const config = {
  apiKey: "AIzaSyBHk2eMtmWvcrS89T1AiwRHCFHrqYmuGtY",
  authDomain: "palm-games-bot.firebaseapp.com",
  projectId: "palm-games-bot",
  storageBucket: "palm-games-bot.firebasestorage.app",
  messagingSenderId: "309277692314",
  appId: "1:309277692314:web:a9dc388a95721fdbe9aa23",
  measurementId: "G-V3FXJ6MD2L",
};

const app = initializeApp(config);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

export const login = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const logOut = async () => {
  await signOut(auth);
};
